module.exports = __webpack_public_path__ + "img/tracking_setting.86afd147.svg";